import { uploadFile } from "api/fileManager";

const fileUploaderApiConfig = {
  uploadFile,
  uploadImagesForPointClouds: () => null,
  uploadVolumesForPointClouds: () => null,
};

export default fileUploaderApiConfig;